query GetAccount($id: ID!) {
  account(
        id: $id
  ) {
        id
        insertedAt
        updatedAt
        deactivatedAt
        name
        notes
        lrnAccess
        smsAccess
        mmsAccess
        requireIpApiAccess
        requireIpGqlAccess
        parentAccount{
          id
          name
        }
      }
}
